@if (isLoading) {
  <div class="cover-spin"></div>
}
<div mat-dialog-content class="mt-3">
  <mat-form-field appearance="outline">
    <mat-label
      [innerHTML]="
        'case_management_portal.manager_dialog.client.label.content'
          | translate: data.client
      "
    ></mat-label>
    <mat-chip-grid #chipList aria-label="Manager selection">
      @for (manager of caseManager; track manager) {
        <mat-chip-row (removed)="remove(manager)">
          {{ manager.name }}
          @if (manager.role !== 'case_manager_admin') {
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </mat-chip-row>
      }
      <input
        placeholder="{{
          'case_management_portal.manager_dialog.manager.placeholder.content'
            | translate
        }}"
        #managerInput
        [formControl]="managerCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
      />
    </mat-chip-grid>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selected($event)"
    >
      @for (manager of filteredCaseManager | async; track manager) {
        <mat-option [value]="manager">
          {{ manager.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (success) {
    <div class="success">
      <small
        [innerHTML]="
          'case_management_portal.manager_dialog.success_message.content'
            | translate
        "
      ></small>
    </div>
  }
  @if (error) {
    <div class="error">
      <small
        [innerHTML]="
          'case_management_portal.manager_dialog.error_message.content'
            | translate
        "
      ></small>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button
    mat-button
    mat-dialog-close
    [innerHTML]="'global.back_button.content' | translate"
  ></button>
</div>
